import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/hooks/useAuth";
import { AppShell } from "@/components/AppShell";
import { RequireAuth, RequireProfile } from "@/components/Guards";
import { InviteClaimer } from "@/components/InviteClaimer";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import ResetPassword from "./pages/ResetPassword";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import GameDetail from "./pages/GameDetail";
import Spieltag from "./pages/Spieltag";
import Ranking from "./pages/Ranking";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";

import Groups from "./pages/Groups";
import Group from "./pages/Group";
import Bonus from "./pages/Bonus";
import KOPhase from "./pages/KOPhase";
import Regeln from "./pages/Regeln";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Teilnahmebedingungen from "./pages/Teilnahmebedingungen";
import Vereine from "./pages/Vereine";
import NotFound from "./pages/NotFound.tsx";

const queryClient = new QueryClient();

const Shell = ({ children, wide }: { children: React.ReactNode; wide?: boolean }) => (
  <RequireAuth><RequireProfile><AppShell wide={wide}>{children}</AppShell></RequireProfile></RequireAuth>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner position="top-center" richColors />
      <BrowserRouter>
        <AuthProvider>
          <InviteClaimer />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/vereine" element={<Vereine />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/" element={<Shell><Dashboard /></Shell>} />
            <Route path="/spiel/:id" element={<Shell><GameDetail /></Shell>} />
            <Route path="/spieltag/:date" element={<Shell><Spieltag /></Shell>} />
            <Route path="/ranking" element={<Shell><Ranking /></Shell>} />
            <Route path="/gruppen" element={<Shell><Groups /></Shell>} />
            <Route path="/gruppe/:slug" element={<Shell><Group /></Shell>} />
            <Route path="/bonus" element={<Shell><Bonus /></Shell>} />
            <Route path="/ko-phase" element={<Shell wide><KOPhase /></Shell>} />
            <Route path="/tabellen" element={<Shell wide><KOPhase /></Shell>} />
            <Route path="/ko" element={<Shell wide><KOPhase /></Shell>} />
            <Route path="/regeln" element={<Shell><Regeln /></Shell>} />
            <Route path="/profil" element={<Shell><Profile /></Shell>} />
            <Route path="/admin" element={<Shell wide><Admin /></Shell>} />
            
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/teilnahmebedingungen" element={<Teilnahmebedingungen />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
